import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsString } from '@pit/core';
import { IDtoResourceFault } from '../interfaces/dto.resource.fault.interface';
import { IDtoResourceFaultType } from '../interfaces/dto.resource.fault.type.interface';
import { DtoResourceFaultType } from './dto.resource.fault.type';
import { DtoResourceFaultPenalty } from './dto.resource.fault.penalty';
import { IDtoResourceFaultPenalty } from '../interfaces/dto.resource.fault.penalty.interface';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { DtoMandator } from './dto.mandator';

// @dynamic
@JsonObject('DtoResourceFault')
export class DtoResourceFault extends ModelEntity implements IDtoResourceFault {

    constructor(initValues: Partial<IDtoResourceFault> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('area', String, true)
    public area?: string = null;

    @JsonProperty('code', String, true)
    public code?: string = null;

    @JsonProperty('description', String, true)
    public description?: string = null;

    @JsonProperty('mandator', DtoMandator, true)
    public mandator?: IDtoMandator = null;

    @JsonProperty('type', DtoResourceFaultType, true)
    public type?: IDtoResourceFaultType = null;

    @JsonProperty('penalties', [DtoResourceFaultPenalty], true)
    public penalties?: IDtoResourceFaultPenalty[] = [];

    public getFullDescription(): string {
        let result: string = this.description;
        if (UtilsString.stringIsNullOrEmpty(this.area) === false) {
            result = this.area + ' ' + result;
        }

        return result;
    }

}
